import React from "react";
import "./footer.css";
import { DateTime } from "luxon";

export function Footer() {
  return (
    <footer
      className="max-md:hidden footer docket-footer p-6 flex flex-col mt-auto docket-gap-2"
      data-testid="footer"
    >
      <div className="flex w-full">
        <div className="flex-1 flex flex-col">
          <p className="logo mx-auto">
            <img alt="Docket" className="footer-logo" src="/assets/images/Docket_Logo_White.png" />©{" "}
            {DateTime.now().year} Docket Health, Inc.
            <br />
            All rights reserved.
          </p>
        </div>
        <div className="flex-1">
          <nav>
            <ul className="navbar flex gap-4">
              <li className="navbar-item">
                <a className="has-text-white" target="_blank" href="https://dockethealth.com/faqs">
                  Immunization FAQs
                </a>
              </li>
              <li className="navbar-item">
                <a
                  className="has-text-white"
                  target="_blank"
                  href="https://docket.care//terms_of_use"
                >
                  Terms of Use
                </a>
              </li>
              <li className="navbar-item">
                <a
                  className="has-text-white"
                  target="_blank"
                  href="https://docket.care//privacy_policy"
                >
                  Privacy Policy
                </a>
              </li>
              <li className="navbar-item">
                <a className="has-text-white" target="_blank" href="https://docket.care//security">
                  Security
                </a>
              </li>
              <li className="navbar-item">
                <a
                  className="has-text-white"
                  target="_blank"
                  href="https://dockethealth.com"
                  data-bs-toggle="modal"
                  data-bs-target="#login-modal"
                >
                  Home
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ul className="social-icons flex gap-4 mx-auto">
        <li className="list-group-item ml-2 mr-2">
          <a href="mailto:info@dockethealth.com">
            <img alt="Email" width="30px" src="/assets/images/footer_email.png" />
          </a>
        </li>
        <li className="list-group-item ml-2 mr-2">
          <a href="https://www.linkedin.com/company/foxhall-wythe-llc">
            <img alt="LinkedIn" width="30px" src="/assets/images/footer_linkedin.png" />
          </a>
        </li>
        <li className="list-group-item ml-2 mr-2">
          <a href="https://twitter.com/DocketHealthApp">
            <img alt="Twitter" width="30px" src="/assets/images/footer_twitter.png" />
          </a>
        </li>
        <li className="list-group-item ml-2 mr-2">
          <a href="https://www.instagram.com/dockethealthapp" className="instagram">
            <img alt="Instagram" width="30px" src="/assets/images/footer_instagram.png" />
          </a>
        </li>
      </ul>
    </footer>
  );
}
